<template>
  <MarketplaceCard
    v-if="zapierIntegrations"
    v-model="zapierIntegrations.zapier.enabled"
    logo-alt="Zapier"
    description="Event-driven workflow automation powered by Zapier."
    learn-more-link="https://zapier.com/apps/sera-systems/integrations"
    cy-selector="marketplaceZapier"
  >
    <template #logo>
      <ZapierLogo class="h-11 w-auto mr-auto" />
    </template>
    <template #configure>
      <div>
        <div
          v-if="zapierIntegrations.zapier.enabled"
          class="link"
          @click="toggleModal"
        >
          View & Copy API Key
        </div>
        <div v-else class="text-gray">View & Copy API Key</div>
      </div>
    </template>
    <template #modal>
      <div>
        <Modal
          v-if="modalOpen"
          title="Zapier Configuration API Key"
          class-name="zapier-config-modal"
          @hide-modal="toggleModal"
        >
          <template #submit>
            <AppButton @click="handleCopy">
              <span
                ><span v-if="!copied">Copy API Key</span
                ><span v-else>Copied to clipboard</span></span
              >
            </AppButton>
          </template>
          <div class="d-flex flex-column">
            <InputField
              v-model="zapierIntegrations.zapier.api_key"
              :disabled="true"
              title="API Key"
              placeholder="API Key"
            />
          </div>
        </Modal>
      </div>
    </template>
  </MarketplaceCard>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import InputField from "@/components/Seranova/InputField/InputField.vue";
import ZapierLogo from "@/images/zapier_logo.svg?component";
import MarketplaceCard from "./MarketplaceCard.vue";

export default {
  components: {
    MarketplaceCard,
    Modal,
    InputField,
    ZapierLogo,
    AppButton: Button
  },
  data() {
    return {
      modalOpen: false,
      copied: false,
      initialEnabledValueLoaded: false
    };
  },
  computed: {
    ...mapState(["zapierIntegrations"])
  },
  watch: {
    "zapierIntegrations.zapier.enabled": function (newValue, oldValue) {
      if (!this.initialEnabledValueLoaded) {
        this.initialEnabledValueLoaded = true;
        return;
      }

      if (newValue !== oldValue) {
        this.updateEnabled();
      }
    }
  },
  mounted() {
    this.fetchZapierIntegrations();
  },
  methods: {
    ...mapActions(["fetchZapierIntegrations", "updateZapierIntegrations"]),
    updateEnabled() {
      const en = this.zapierIntegrations.zapier.enabled;
      this.updateZapierIntegrations({
        zapierIntegrations: { zapier: { enabled: en } }
      }).then(() => {
        window.notify.success(`Zapier ${en ? "enabled" : "disabled"}!`);
      });
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    handleCopy() {
      navigator.clipboard
        .writeText(this.zapierIntegrations.zapier.api_key)
        .then(() => (this.copied = true));
    }
  }
};
</script>
